import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import AppPageHeader from 'components/common/AppPageHeader';
import PaymentComponent from './components/PaymentComponent';

const Modal = styled.div`
  position: relative;
`;

const ImageContainer = styled.div`
  position: absolute;
  right: -8rem;
  width: 92.4rem;
  background: url(/images/mountain.svg) no-repeat;
  background-position: bottom;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const Image = styled.div`
  width: 44.6rem;
  height: 40.2rem;
  background: url(/images/moped.svg) no-repeat;
  margin-right: 7rem;
`;

CardModal.propTypes = {
  cardDetails: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired
};

function CardModal({cardDetails, goBack}) {
  function render() {
    let title = cardDetails && cardDetails.cardNumber ? 'Update card details' : 'Add card details';

    return (
      <Modal>
        <AppPageHeader title={title} goBack={goBack} />

        <PaymentComponent />

        <ImageContainer>
          <Image />
        </ImageContainer>
      </Modal>
    );
  }

  return render();
}

export default CardModal;
